/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { STATUSCODEDATA } from './sTATUSCODEDATA';


export interface AUDITTRAILINFO {
    operationDate: Date;
    operationType: string;
    requesterId?: string;
    status: AUDITTRAILINFO.StatusEnum;
    /**
     * Provides the reason of the status. Present only if the operation was not successful.
     */
    statusCodeData?: STATUSCODEDATA;
    recordId?: number;
    /**
     * ISDP AID
     */
    isdPAid?: string;
    /**
     * eUICC-ID
     */
    eid: string;
    imei?: string;
    /**
     * Mobile Subscriber Integrated Services Digital Network Number
     */
    msisdn?: string;
    /**
     * International Mobile Subscriber Identity
     */
    imsi?: string;
    /**
     * Mobile Network Operator ID
     */
    mnoId?: string;
    /**
     * Integrated Circuit Card ID
     */
    iccid?: string;
    /**
     * The last request state. It may be used to identify the point of failure.
     */
    lastRequestState?: string;
    /**
     * Identification of the transaction used to link multiple SR records to a single DP operation.
     */
    transactionId?: string;
}
export namespace AUDITTRAILINFO {
    export type StatusEnum = 'SUCCESS' | 'WARNING' | 'FAILED' | 'EXPIRED' | 'IN_PROCESS' | 'CANCELED' | 'UNKNOWN';
    export const StatusEnum = {
        SUCCESS: 'SUCCESS' as StatusEnum,
        WARNING: 'WARNING' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        EXPIRED: 'EXPIRED' as StatusEnum,
        INPROCESS: 'IN_PROCESS' as StatusEnum,
        CANCELED: 'CANCELED' as StatusEnum,
        UNKNOWN: 'UNKNOWN' as StatusEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/aUDITTRAILINFO.ts